import amplitude from 'amplitude-js';
import { takeLatest } from 'redux-saga/effects';

import { LOG_AMPLITUDE_EVENT, SET_AMPLITUDE_USER_ID } from '../actions/amplitude';

const callLogAmplitudeEvent = function* callLogAmplitudeEvent({ eventName, eventProperties }) {
  amplitude.getInstance().logEvent(eventName, eventProperties);
};

const watchCallLogAmplitudeEvent = function* watchCallLogAmplitudeEvent() {
  yield takeLatest(LOG_AMPLITUDE_EVENT, callLogAmplitudeEvent);
};

const callSetAmplitudeUserId = function* callSetAmplitudeUserId({ userId }) {
  amplitude.getInstance().setUserId(userId);
};

const watchSetAmplitudeUserId = function* watchSetAmplitudeUserId() {
  yield takeLatest(SET_AMPLITUDE_USER_ID, callSetAmplitudeUserId);
};

export {
  watchCallLogAmplitudeEvent,
  watchSetAmplitudeUserId,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/amplitude.js